module.exports = __webpack_public_path__ + "4d0ae138.png";